import {PolicyDetailPage} from './PolicyDetailPage';
export default PolicyDetailPage;
